import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("BILLING_GROUPS");
const CRUD_ACTION_HANDLERS = getActionHandler("BILLING_GROUPS");

export default function billingGroups(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
